import { render, staticRenderFns } from "./delayTime.vue?vue&type=template&id=593ae5ae&scoped=true"
import script from "./delayTime.vue?vue&type=script&lang=js"
export * from "./delayTime.vue?vue&type=script&lang=js"
import style0 from "./delayTime.vue?vue&type=style&index=0&id=593ae5ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ae5ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593ae5ae')) {
      api.createRecord('593ae5ae', component.options)
    } else {
      api.reload('593ae5ae', component.options)
    }
    module.hot.accept("./delayTime.vue?vue&type=template&id=593ae5ae&scoped=true", function () {
      api.rerender('593ae5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blameAndPunishment/takeResponsibility/component/delayTime.vue"
export default component.exports